<template>
  <div class="axios-uplaod">
    <div class="file-name" v-show="file">
      <el-tag type="success" effect="plain">
        {{ fileName }}
      </el-tag>
    </div>
    <div @click="selectFile">
      <slot></slot>
    </div>
    <input type="file" ref="upFile" @change="handleFileChange($event)" />
  </div>
</template>

<script>
/**
 * ====只支持单文件====
 * 组件接收参数:
 *  -fileType 数组 校验类型
 *  -maxFileSize 数字 校验大小
 *
 * 父组件接收事件
 *  -nowFile 当前选中的文件  file对象, blob, aliFileUrl阿里云地址
 */
import debounce from "lodash/debounce";
import defaultSettings from "@/modules/config/defaultSettings";
export default {
  props: {
    fileType: {
      type: Array,
      default: () => []
    },
    maxFileSize: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      file: null,
      fileName: ""
    };
  },
  created() {
    this.upUrl = defaultSettings.serviceUrl;
  },
  methods: {
    uplaod() {
      let param = new FormData();
      param.append("file", this.file);
      let url = this.upUrl + "/file/uploadSignature";
      this.$http
        .post(url, param, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(({data:res}) => {
          console.log("xxxxxxxxxxxxxxxxxxxxx",res);
          if (res.code != 200) {
            return this.$message.error("上传失败, 请重试");
          }
          this.fileName = this.file.name;
          let URL = window.URL || window.webkitURL;
          let blob = URL.createObjectURL(this.file);
          let aliFileUrl = res.body.url_0;
          this.$emit("nowFile", this.file, blob, aliFileUrl);
        })
        .catch(err => {
          this.$message.error("上传失败, 请重试");
          console.error(err);
        });
    },
    selectFile: debounce(
      function() {
        this.$refs.upFile.click();
      },
      1000,
      {
        leading: true,
        trailing: true
      }
    ),
    handleFileChange(event) {
      // 如果未选择文件，则直接返回
      if (!event.target.files.length) {
        return this.$message.warning("取消选择");
      }
      let fileName = event.target.files[0].name;
      let fileSize = event.target.files[0].size;

      // ====================== 文件类型校验 ======================
      let nowType = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (this.fileType.length !== 0 && this.fileType.indexOf(nowType) === -1) {
        this.$message.warning(`请选择${this.fileType.join("、")}类型的文件!`);
        return;
      }
      // ====================== 文件大小校验 ======================
      if (this.maxFileSize !== -1 && fileSize > this.maxFileSize) {
        this.$message({
          title: "提示",
          message: `附件大小不能大于${this.maxFileSize / (1024 * 1024)}M！`,
          type: "warning",
          duration: 2000
        });
        return;
      }
      this.file = event.target.files[0];
      this.uplaod();
    }
  }
};
</script>

<style lang="less" scoped>
.axios-uplaod input {
  display: none;
}
.file-name {
  display: flex;
}
.el-tag {
  margin-left: 10px;
}
</style>
